const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const formatMessage = require('format-message');
const SensorPeripheral = require('../common/sensor-peripheral');
const { default: bleUtils } = require('../../util/ble');
const { BLE_CONFIG } = require('../../util/bleCharac');


/**
 * 无线数字温湿度传感器
 * 
 * @readonly
 */
const DIVECE_OPT = {
    type: 'sensor'
};

// const BLE_CONFIG = {
//     prefix: 'LM',
//     SERVICE_UUID: 0x02FF,
//     temperature: 0x0300,
//     humidity: 0x0301,
// }
/**
 * Manage communication with a Arduino esp32 peripheral over a Scratch Link client socket.
 */
class YMTH1D extends SensorPeripheral {
    /**
     * Construct a Arduino communication object.
     * @param {Runtime} runtime - the Scratch runtime
     * @param {string} deviceId - the id of the extension
     * @param {string} originalDeviceId - the original id of the peripheral, like xxx_arduinoUno
     */
    constructor(runtime, deviceId, originalDeviceId) {
        super(runtime, deviceId, originalDeviceId, null, BLE_CONFIG, DIVECE_OPT);
    }
}

class ScratchYMTH1DDevice {

    /**
     * @return {string} - the ID of this deivce.
     */
    get DEVICE_ID() {
        return 'YMTH1D';
    }

    /**
     * Construct a set of Arduino blocks.
     * @param {Runtime} runtime - the Scratch runtime.
     * @param {string} originalDeviceId - the original id of the peripheral, like xxx_arduinoUno
     */
    constructor(runtime, originalDeviceId) {
        /**
         * The Scratch runtime.
         * @type {Runtime}
         */
        this.runtime = runtime;

        
        this._peripheral = new YMTH1D(this.runtime, this.DEVICE_ID, originalDeviceId);
        this.bleUtils = new bleUtils();
    }

    getInfo() {
        return [{
            id: 'YMTH1D',
            name: formatMessage({
                id: 'YMTH1D.categoryName',
                default: 'YM TH1D',
                description: 'Label for the YM TH1D extension category'
            }),
            color1: "#76C75E",
            color2: "#6DB14D",
            color3: "#64A23C",
            blocks: [
                {
                    opcode: 'connect',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMTH1D.ble.connect',
                        default: 'connect to YM-TH1D-[DEVICE_NAME]',
                        description: 'Connect to YM TH1D'
                    }),
                    arguments: {
                        DEVICE_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: ' ',
                        }
                    }
                },
                {
                    opcode: 'disConnect',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMTH1D.ble.disconnect',
                        default: 'disconnect from YM TH1D',
                        description: 'Disconnect from YM TH1D'
                    })
                },
                {
                    opcode: 'getTemperature',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMTH1D.getTemperature',
                        default: 'get temperature',
                        description: 'Get the temperature of the light'
                    })
                },
                {
                    opcode: 'getHumidity',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMTH1D.getHumidity',
                        default: 'get humidity',
                        description: 'Get the current humidity'
                    })
                },
            ],
            menus: {}
        }];
    }

    async connect(args) {
        const deviceName = 'YM-TH1D-' + (args.DEVICE_NAME?.trim() || "");
        console.log(`Connecting to YM TH1D device: ${deviceName}`);
        const connected = await this.isConnected();
        if (connected) {
            console.log('Already connected to device');
            return;
        }
        try {
            await this.bleUtils.connect(deviceName, BLE_CONFIG.SERVICE_UUID);
            console.log(`Connected to device: ${deviceName}`);

        } catch (error) {
            console.error(`Failed to connect to ${deviceName}:`, error);
        }
    }

    async isConnected() {
        console.log('Checking if device is connected');
        return this.bleUtils.device !== null && this.bleUtils.device.gatt.connected;
    }

    async disConnect() {
        console.log('Disconnecting from YM TH1D device');
        if (this.bleUtils.device) {
            try {
                await this.bleUtils.disConnect(this.bleUtils.device);
                console.log('Disconnected from device');
            } catch (error) {
                console.error('Failed to disconnect:', error);
            }
        }
    }

    async getTemperature() {
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.temperature);
                const dataView = await this.bleUtils.readCharacteristic(characteristic);
                if (dataView?.buffer instanceof ArrayBuffer) {
                    //解析数据
                    let buffer = Array.from(new Uint8Array(dataView.buffer));
                    const hexStr = buffer.map(_ => {
                        return this.bleUtils.int2Hex(_);
                    }).reverse().join("");
                    const temperature = this.bleUtils.hex2float(hexStr, 2, 4);
                    console.log(`temperature: ${temperature}`);
                    // 设置精灵坐标
                    // this.runtime.targets.forEach(target => {
                    //     if (target.isSprite) {
                    //         // 设置x和y坐标
                    //         target.setXY(temperature, target.y);
                    //     }
                    // });
                    return temperature;
                }
            } catch (error) {
                console.error('Failed to set temperature:', error);
            }
        }
    }

    async getHumidity() {
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.humidity);
                const dataView = await this.bleUtils.readCharacteristic(characteristic);
                if (dataView?.buffer instanceof ArrayBuffer) {
                    //解析数据
                    let buffer = Array.from(new Uint8Array(dataView.buffer));
                    const hexStr = buffer.map(_ => {
                        return this.bleUtils.int2Hex(_);
                    }).reverse().join("");
                    const humidity = parseInt(hexStr, 16);
                    console.log(`humidity: ${humidity}`);
                    // 设置精灵坐标
                    // this.runtime.targets.forEach(target => {
                    //     if (target.isSprite) {
                    //         // 设置x和y坐标
                    //         target.setXY(target.x, humidity);
                    //     }
                    // });
                    return humidity;
                }
            } catch (error) {
                console.error('Failed to set humidity:', error);
            }
        }
    }

}

module.exports = ScratchYMTH1DDevice;